import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

const MainApp = require('./MainApp').default;

Sentry.init({
  dsn: 'https://644d5458e11a4e3f8edc4c3b2c4b8d2d@logs.institutototum.com.br/11',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0, // Adjust in production (e.g. 0.2)
});

const SentryApp = Sentry.withErrorBoundary(MainApp, {
  fallback: <p>Something went wrong.</p>,
});

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
});

window.addEventListener('error', (event) => {
  Sentry.captureException(event.error || event);
});

const originalConsoleError = console.error;
console.error = (...args) => {
  Sentry.captureMessage(args.join(' '), 'error');
  originalConsoleError(...args);
};

const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  Sentry.captureMessage(args.join(' '), 'warning');
  originalConsoleWarn(...args);
};

const rootEl = document.getElementById('app-site');

const render = () => {
  ReactDOM.render(<SentryApp />, rootEl);
};

render();

export default SentryApp;
